import { render, staticRenderFns } from "./Overview.vue?vue&type=template&id=4d4b8f44&"
import script from "./Overview.vue?vue&type=script&lang=js&"
export * from "./Overview.vue?vue&type=script&lang=js&"
import style0 from "./Overview.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/__w/ddv-home/ddv-home/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d4b8f44')) {
      api.createRecord('4d4b8f44', component.options)
    } else {
      api.reload('4d4b8f44', component.options)
    }
    module.hot.accept("./Overview.vue?vue&type=template&id=4d4b8f44&", function () {
      api.rerender('4d4b8f44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ddv-home/Overview.vue"
export default component.exports